import React, { useEffect, version } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import ScrollToTop from "./component/scrollToTop/ScrollToTop";
import "bootstrap/dist/css/bootstrap.min.css";

// Home Pages Import
import DigitalAgency from "./pages/DigitalAgency";
import CreativeAgency from "./pages/CreativeAgency";
import PersonalPortfolio from "./pages/PersonalPortfolio";
import HomeStartup from "./pages/HomeStartup";
import CorporateAgency from "./pages/CorporateAgency";

// Blog Import
import BlogGridView from "./pages/BlogGrid";
import BlogCategory from "./pages/Category";
import BlogArchive from "./pages/Archive";
import BlogDetails from "./pages/BlogDetails";

// Service
import ServiceOne from "./pages/ServiceOne";
import ServiceTwo from "./pages/ServiceTwo";
import ServiceDetails from "./pages/ServiceDetails";

// Project
import ProjectGridOne from "./pages/ProjectGridOne";
import ProjectGridTwo from "./pages/ProjectGridTwo";
import ProjectGridThree from "./pages/ProjectGridThree";
import ProjectGridFive from "./pages/ProjectGridFive";
import ProjectGridFour from "./pages/ProjectGridFour";
import ProjectDetails from "./pages/ProjectDetails";

// Pages
import Splash from "./pages/Splash";
import NewsHome from "./pages/NewsHome";
import AboutUs from "./pages/AboutUs";
import OurOffice from "./pages/OurOffice";
import OurClients from "./pages/OurClients";
import Team from "./pages/Team";
import TeamDetails from "./pages/TeamDetails";
import CaseStudy from "./pages/CaseStudy";
import CaseDetails from "./pages/CaseStudyDetails";
import Testimonials from "./pages/Testimonials";
import PricingTable from "./pages/PricingTable";
import Typography from "./pages/Typography";
import Contact from "./pages/Contact";
import ErrorPage from "./pages/404";
import ComingSoon from "./pages/ComingSoon";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";

// Css Import
import "./assets/scss/app.scss";
import { useDispatch, useSelector } from "react-redux";
import { useBlog } from "./hooks/useBlog";
import OnlineProcedures from "./pages/OnlineProcedures";
import useSWR from "swr";
import { coreConfig } from "./site-config";
import { setStoreItems } from "./store/store";
import { apiGet } from "./services/network";
import { initGA } from "./services/analytics";

const customer_id = window["customer_id"];
const ConfigurationRequired = ({ children }) => {
  var configSite = window["configSite"];
  var customerId = window["customer_id"];
  const { getMainBlog } = useBlog();

  const { loaded, siteConfig } = useSelector((state) => state.store);
  const { data, error, mutate } = useSWR(
    `${coreConfig.urls.site.config}?version=${siteConfig.version || 0}`,
    apiGet
  );
  const initialized = React.useRef(false);
  const dispatch = useDispatch();
  React.useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      getMainBlog();
    }
  }, [getMainBlog]);
  useEffect(() => {
    if (data) {

      var storeItems = { ...data.data, siteConfig: data.data.config, loaded: true }
      // data.data.customers is an array of customer objects which each has a customers array
      // we need concat all customers into a single array
      var customers = data.data.customers?.map(customer => customer.customers).flat() || [];
      var matchCustomer = customers.find(customer => customer.id === parseInt(customer_id));
      
      if (matchCustomer) {
        storeItems.currentCustomer = matchCustomer;
      } else {
        console.error("No matching customer found for customer_id: ", customer_id);
      }

      dispatch(setStoreItems(storeItems));
    }
  }, [data, error]);
  if (!loaded) {
    return <div>Loading...1</div>;
  }
  return <>{children}</>;
};
const SiteConfigLoader = ({ children }) => {
  const { siteConfig, customers } = useSelector((state) => state.store);
  const dispatch = useDispatch();
  const loadCustomers = () => {
    var localCustomers = localStorage.getItem("customers");
    if (localCustomers) {
      localCustomers = JSON.parse(localCustomers);
      var matchCustomer = localCustomers.find(
        (customer) => customer.id === parseInt(customer_id)
      );
      console.log(matchCustomer);
      dispatch(
        setStoreItems({
          customers: localCustomers,
          currentCustomer: matchCustomer || null,
        })
      );
    }
  };
  const loadSiteConfig = () => {
    // var _localConfig = localStorage.getItem("config");
    // var defaultConfig = {
    //   version: 0,
    // };
    // if (_localConfig) {
    //   try {
    //     defaultConfig = JSON.parse(_localConfig);
    //   } catch (e) {
    //     console.log("error parsing local config", e);
    //     defaultConfig = {
    //       version: 0,
    //     };
    //   }
    // }
    // dispatch(
    //   setStoreItems({
    //     siteConfig: defaultConfig,
    //   })
    // );
  };
  useEffect(() => {
    if (!customers || customers.length === 0) {
      loadCustomers();
      loadSiteConfig();

    }
  }, [customers]);

  if (!siteConfig) {
    return <div>Loading...2</div>;
  }
  return (
    <ConfigurationRequired siteConfig={siteConfig}>
      {children}
    </ConfigurationRequired>
  );
};

const App = () => {
  // Inicializar Google Analytics
  useEffect(() => {
    // Obtener el Measurement ID desde la configuración del sitio o variable de entorno
    const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || window['GA_MEASUREMENT_ID'];
    if (GA_MEASUREMENT_ID) {
      initGA(GA_MEASUREMENT_ID);
    }
  }, []);

  // Determinar el modo de la aplicación
  const appMode = window['APP_MODE'] || 'news'; // Por defecto es 'news'
  const HomePage = appMode === 'splash' ? Splash : NewsHome;

  return (
    <SiteConfigLoader>
      <Router>
        <ScrollToTop>
          <Routes>
            {/* if node env development server /themes/theme.js?*** to dev.arkadu.com/themes/theme.js?** */}
            {process.env.NODE_ENV === "development" && (
              <Route
                path={process.env.PUBLIC_URL + "/themes/theme.js"}
                element={
                  <Navigate
                    to="https://dev.arkadu.com/themes/theme.js?v=2"
                    replace
                  />
                }
              />
            )}
            <Route path={process.env.PUBLIC_URL + "/"} element={<HomePage />} />
            <Route
              path={process.env.PUBLIC_URL + "/procedures"}
              element={<OnlineProcedures />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/video/:id"}
              element={<BlogDetails />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/digital-agency"}
              element={<DigitalAgency />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/creative-agency"}
              element={<CreativeAgency />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/personal-portfolio"}
              element={<PersonalPortfolio />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/home-startup"}
              element={<HomeStartup />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/corporate-agency"}
              element={<CorporateAgency />}
            />

            {/* Blogs */}
            <Route
              path={process.env.PUBLIC_URL + "/blog-grid/"}
              element={<BlogGridView />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/category/:slug"}
              element={<BlogCategory />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/archive/:slug"}
              element={<BlogArchive />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/post/:slug"}
              element={<BlogDetails />}
            />

            {/* Service */}
            <Route
              path={process.env.PUBLIC_URL + "/service-one/"}
              element={<ServiceOne />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/service-two/"}
              element={<ServiceTwo />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/service-details/:slug"}
              element={<ServiceDetails />}
            />

            {/* Project  */}
            <Route
              path={process.env.PUBLIC_URL + "/project-grid-one"}
              element={<ProjectGridOne />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/project-grid-two"}
              element={<ProjectGridTwo />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/project-grid-three"}
              element={<ProjectGridThree />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/project-width-one"}
              element={<ProjectGridFour />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/project-width-two"}
              element={<ProjectGridFive />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/project-details/:slug"}
              element={<ProjectDetails />}
            />

            {/* Pages  */}
            <Route
              path={process.env.PUBLIC_URL + "/about-us"}
              element={<AboutUs />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/our-office"}
              element={<OurOffice />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/our-clients"}
              element={<OurClients />}
            />
            <Route path={process.env.PUBLIC_URL + "/team"} element={<Team />} />
            <Route
              path={process.env.PUBLIC_URL + "/team-details/:slug"}
              element={<TeamDetails />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/case-study"}
              element={<CaseStudy />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/case-details/:slug"}
              element={<CaseDetails />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/testimonials"}
              element={<Testimonials />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/pricing-table"}
              element={<PricingTable />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/typography"}
              element={<Typography />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/contact"}
              element={<Contact />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/404"}
              element={<ErrorPage />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/coming-soon"}
              element={<ComingSoon />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/privacy-policy"}
              element={<PrivacyPolicy />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/terms-use"}
              element={<TermsOfUse />}
            />
          </Routes>
        </ScrollToTop>
      </Router>
    </SiteConfigLoader>
  );
};

export default App;
